import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "value", "selected", "className", "onSelect", "description", "multiline"];
import { CommandItem } from "../../_shadcn-native-components/command";
import { cn } from "../../utils";
import { sanitizeText } from "../utils/sanitize-text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DropdownTextItem = function DropdownTextItem(_ref) {
  var text = _ref.text,
    value = _ref.value,
    selected = _ref.selected,
    className = _ref.className,
    _onSelect = _ref.onSelect,
    description = _ref.description,
    multiline = _ref.multiline,
    itemProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(CommandItem, _objectSpread(_objectSpread({
    className: cn(multiline && 'tw-items-start tw-overflow-hidden', className),
    selected: selected,
    value: value,
    onSelect: function onSelect() {
      return _onSelect(value);
    }
  }, itemProps), {}, {
    children: description ? /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-w-full",
      children: [/*#__PURE__*/_jsx("h5", {
        className: cn('tw-font-subtitle5 tw-w-full', multiline ? 'tw-break-words tw-min-w-0' : 'tw-truncate'),
        children: sanitizeText(text)
      }), /*#__PURE__*/_jsx("p", {
        className: cn('tw-font-body5 tw-text-neutral-light-700 tw-w-full', multiline ? 'tw-break-words tw-min-w-0' : 'tw-truncate'),
        children: sanitizeText(description)
      })]
    }) : /*#__PURE__*/_jsx("p", {
      className: multiline ? 'tw-break-words tw-min-w-0' : 'tw-truncate',
      children: sanitizeText(text)
    })
  }), value);
};